<template>
    <div style="height: 100%; overflow: auto;width: 100%;background-color: #fff">
        <div class="report-header">
            <span>风控报告</span>
            <div class="handle-btn" v-if="!editing">
                <el-button size="small" @click="() => $router.go(-1)">返回</el-button>
            </div>
            <div class="export-btn" v-if="type !== 'origin'">

                <!--                <el-button size="small" type="primary" @click="exportReport2" >导出报告</el-button>-->
                <template v-if="!editing">
                    <el-button size="small" type="primary" @click="edit">编辑</el-button>
                    <el-button size="small" @click="publish">发布</el-button>
                </template>
                <template v-else>
                    <el-button size="small" type="primary" @click="save">保存</el-button>
                    <el-button size="small" @click="reload">取消</el-button>
                </template>
            </div>
        </div>
        <el-image
            ref="img"
            style="width: 0; height: 0"
            :preview-src-list="previewList">
        </el-image>
        <div ref="content" class="report-wrapper">
            <Row class="page3 report">
                <TopList :data2="data2" :pieData="pieData"></TopList>
                <div class="part2 page_split table" v-if="tableData.length">
                    <TableList :tableData="tableData"></TableList>
                </div>
                <div class="detail" @input="handleInput" id="reportEditDetail">
                    <div v-for="(risk, riskIdx) in data3" :key="riskIdx" class="page_split">
                        <p class="fz28 golden pb10"
                           v-if="(riskIdx === 0) || (risk.companyName !== data3[riskIdx - 1].companyName)"><span>{{
                                risk.companyName }} - 关键风险指标分析</span></p>
                        <p class="fz24 golden pb8"
                           v-if="(riskIdx === 0) || (risk.companyName !== data3[riskIdx - 1].companyName) || ((risk.companyName === data3[riskIdx - 1].companyName) && (risk.riskCategory !== data3[riskIdx - 1].riskCategory))">
                            <span>{{ risk.riskCategory }}</span></p>
                            <div class="deleteGreenWrap" v-if="JSON.stringify(risk.deleteTitleList).indexOf('allDelete') == -1">
                        <div class="green pb4 fz24 deleteiconwrap">
                            <p class="green bold" style="display:flex;align-items:center;">
                                <div style="display:flex;align-items:center;" class="section">
                                <span>{{ risk.subRisk }}{{ options[risk.riskControllerStatus] ? options[risk.riskControllerStatus].label : "" }}
                                </span>
                                <i class="el-icon-delete deleteEdit" @click="e => deleteNode(e, riskIdx, 'green')" style="display:relative;z-index:9;" v-if="editing"></i>
                            </div>   
                            </p>
                            <el-select :disabled="!editing || !data3Detail[riskIdx]['subrisk']" v-model="risk.riskControllerStatus" placeholder="请选择" size="mini" class="select-wrapper"
                                       @change="(e) => changeStatus(e, riskIdx)">
                                <el-option
                                    v-for="(item,index) in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="index">
                                </el-option>
                            </el-select>
                            <div style="margin-top: -40px"></div>
                        </div>
                        <div class="blue pb8 section" v-if="!risk.deleteTitleList.includes('基本信息')">
                            <p class="fz20 pb4">
                                <b>基本信息</b>
                                <i v-if="editing" class="el-icon-delete" @click="e => deleteNode(e, riskIdx, '基本信息')"></i>
                            </p>
                            <p>
                                1.
                                <span>{{ risk.subRisk }}</span>所有关键风险指标共<span>{{ risk.kriCount
                                }}</span>个，截止<span>{{
                                    formatDate(risk.dataversion) }}</span>，<span>{{ risk.alertKriCount
                                }}</span>个指标处于预警状态，<span>{{
                                    risk.nonAlertKriCount }}</span>个指标处于非预警状态。
                            </p>
                            <template v-if="risk.alertStatusKri">
                                <p>
                                    2. 处于预警状态的关键风险指标为：<span>{{(risk.alertStatusKri || "").replace(/\ /g, "、") }}</span>。
                                </p>
                            </template>
                        </div>
                        <div class="blue pb8 section" v-if="!risk.deleteTitleList.includes('风险分析')">
                            <p class="fz20 pb4">
                                <b>风险分析</b>
                                <i v-if="editing" class="el-icon-delete" @click="e => deleteNode(e, riskIdx, '风险分析')"></i>
                            </p>
                            <p :contenteditable="contentEditable" :data-key="`${riskIdx}_riskAnalysis`">
                                <span>{{risk.riskAnalysis || "-"}}</span>
                            </p>
                        </div>
                        <div class="blue pb8 section" v-if="!risk.deleteTitleList.includes('趋势分析')">
                            <p class="fz20 pb4">
                                <b>趋势分析</b>
                                <i v-if="editing" class="el-icon-delete" @click="e => deleteNode(e, riskIdx, '趋势分析')"></i>
                            </p>
                            <p :contenteditable="contentEditable" :data-key="`${riskIdx}_trendAnalysis`">
                                <span>{{ risk.trendAnalysis || "-" }}</span>
                            </p>
                        </div>
                        <div v-if="editing" class="no-print pb16">
                            <el-upload
                                class="upload-btn"
                                multiple
                                :http-request="e => customUpload(e, riskIdx)"
                                action="#"
                                :show-file-list="false"
                                accept="image/*">
                                <el-button size="small" type="primary">点击上传图片</el-button>
                            </el-upload>
                        </div>
                        <template v-if="risk.images && risk.images.length">
                            <div class="img-wrapper page_split" >
                                <div class="img-item"
                                     v-for="(img, idx) in risk.images" :key="idx"
                                     :style="'margin-bottom: 20px'">
                                    <div class="img-name">
                                        <p :contenteditable="contentEditable"  :data-key="`${riskIdx}_images_${idx}_imgName`">{{ img.imgName }}</p>
                                    </div>
                                    <div class="img-content" :style="'background-image: url(' + encodeURI(img.filePath) + ')'">
                                        <div class="img-handler">
                                            <i class="el-icon-view" @click="viewImg(img.filePath)"></i>
                                            <i v-if="editing" class="el-icon-delete" @click="deleteImg(riskIdx, idx)"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <div class="blue pb8 page_split section" v-if="(risk.alertKriCount > 0) && !risk.deleteTitleList.includes('预警KRI详情')">
                            <p class="fz20 pb4">
                                <b>预警KRI详情</b>
                                <i v-if="editing" class="el-icon-delete" @click="e => deleteNode(e, riskIdx, '预警KRI详情')"></i>
                            </p>
                            <div v-for="(kri, kriIdx) in risk.kriDetailList" :key="kriIdx">
                                <p class="fz20 pb4">
                                    <span>{{ kri.kriName }}</span> <span>{{ statusMap[kri.kriStatus] }}</span>
                                </p>
                                <p class="blue">
                                    基本信息：
                                </p>
                                <p>
                                    截止<span>{{ formatDate(risk.dataversion) }}</span>，<span
                                >{{ kri.kriName }}</span>触发预警，该关键风险指标<span>已持续预警</span> <span
                                >{{ kri.kriWarningDuration }}</span>
                                    <span>天</span>。该关键风险指标的实际数据为<span
                                >{{ kri.kriActualValue }}</span><span>{{
                                        getUnit(risk.companyName) }}</span>，阈值设定为<span
                                >{{ kri.kriThresholdValue }}</span><span>{{
                                        getUnit(risk.companyName) }}</span>，实际数据<span
                                >{{ kri.comparisonOperator }}</span>阈值设定<span
                                >{{ kri.difference }}</span><span>{{ getUnit(risk.companyName) }}</span>。
                                </p>
                                <p>
                                    相关响应：
                                </p>
                                <p :contenteditable="contentEditable"
                                   :data-key="`${riskIdx}_kriDetailList_${kriIdx}_relatedResponse`">
                                    <span>{{ kri.relatedResponse || "-" }}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </Row>
        </div>
    </div>
</template>

<script>
import "swiper/dist/css/swiper.min.css";
import "swiper/dist/js/swiper.min";
import { useDataStore } from "@/store";
import { mapActions } from "pinia";

import pdf from "../utils/pdf";
import { header } from "../utils/pdf";
import { Loading } from "element-ui";
import TableList from "./components/report/TableList";
import TopList from "./components/report/TopList.vue";
import {sortedCompanys, sortedKeys, statusMap} from "./components/report/data";
import {data1, data2, data3} from "./components/report/data";
import {
    buildReportApi, getOriginReportDetailApi,
    getReportDetailByVeApi,
    getReportOverviewApi,
    getReportPieDataApi, getReportPublishVersionApi,
    publishReportApi,
    updateReportApi,
    uploadReportImgApi
} from "@/api/report";
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

export default {
    name: "page3",
    components: {
        TopList,
        TableList,
        quillEditor
    },
    created() {
        this.month = this.$route.query.month;
        this.type = this.$route.params.type;
        this.setTitle("风控报告");
        this.$nextTick(() => {
            this.getData();
        });
    },
    computed: {
        statusMap() {
            return statusMap
        },
        contentEditable() {
            return this.editing.toString();
        },
        pieData() {
            const data = JSON.parse(JSON.stringify(this.data1));
            /**
             * 返回结果为 {
             *     [监控口径]: [{
             *         name: [风险大嘞],
             *         data: {
             *             [风险名称]: {
             *                 [kri]: [预警情况]
             *             }
             *         }
             *     }]
             * }
             *
             */
            let res = {};
            // 监控口径列表
            let level1Keys = Object.keys(data);
            // 统计同一风险大类出现的次数，最后次数多的往上放
            let level2KeysObj = {};
            for (let level1Key of level1Keys) {
                res[level1Key] = [];
                const level2Keys = Object.keys(data[level1Key]).sort((a, b) => sortedKeys.indexOf(a) - sortedKeys.indexOf(b));
                for (let level2Key of level2Keys) {
                    level2KeysObj[level2Key] = (level2KeysObj[level2Key] || 0) + 1;
                    res[level1Key] = level2Keys.map(level2Key => {
                        return {
                            name: level2Key,
                            data: data[level1Key][level2Key]
                        };
                    });
                }
            }
            // 按照风险大类出现的次数由高到低重新排序
            for (let level1Key of level1Keys) {
                res[level1Key] = res[level1Key].sort((a, b) => level2KeysObj[b.name] - level2KeysObj[a.name]);
            }
            level1Keys = level1Keys.sort((a, b) => {
                return res[b].length - res[a].length;
            });

            let list = [];
            while (level1Keys.some(key => res[key].length > 0)) {
                list.push(level1Keys.map(key => {
                    return {
                        key: key,
                        data: res[key].shift()
                    };
                }));
            }
            return list.map(t => {
                return t.sort((a, b) => {
                    return sortedCompanys.indexOf(a.key) - sortedCompanys.indexOf(b.key);
                })
            });
        },
        tableData() {
            const res = []
            const data = JSON.parse(JSON.stringify(this.data1))
            const companys = Object.keys(data);
            companys.forEach(company => {
                const types = Object.keys(data[company]);
                types.forEach(type => {
                    const risks = Object.keys(data[company][type]);
                    risks.map(risk => {
                        for (let kri in data[company][type][risk]) {
                            if (data[company][type][risk][kri]["当前预警状态"] !== "0") {
                                res.push({
                                    company,
                                    type,
                                    risk,
                                    kri,
                                    ...data[company][type][risk][kri]
                                })
                            }
                        }
                    })

                })
            })
            return res
        }
    },
    data() {
        return {
            editing: false,
            data2: {},
            data1: {},
            data3: [],
            data3Detail: {},
            savedContent: null,
            image: "",
            month: "",
            type: "new",
            header,
            list: [],
            previewList: [],
            // TODO 状态枚举有变化，对接口时再确认一下
            options: [{
                value: "可控",
                label: "可控"
            }, {
                value: "需持续关注",
                label: "需持续关注"
            }, {
                value: "呈上升趋势",
                label: "呈上升趋势"
            }],
            imgs: []
        };
    },
    methods: {
        ...mapActions(useDataStore, ["setTitle", "setLeftTop", "setBackurl"]),

        formatDate(date) {
            return `${date.slice(0, 4)}.${date.slice(4, 6)}`;
        },
        async exportReport() {
            const loading = Loading.service({
                lock: true,
                text: "正在导出报告...",
                background: "rgba(0,0,0,0.5)",
                fullscreen: true
            });
            try {
                // const eles = document.querySelectorAll("ul.content > li > div")
                await pdf(".report", {
                    single: true
                });
            } finally {
                loading.close();
            }
        },
        edit() {
            if (!this.savedContent) {
                const ele = document.querySelector("#reportEditDetail");
                this.savedContent = ele.cloneNode(true);
            }
            this.$nextTick(() => {
                this.editing = true;
            });
        },
        async publishDone () {
            const loading = this.$loading({
                lock: true,
                text: "发布中",
                background: "rgba(0, 0, 0, 0.7)"
            });
            try {
                await publishReportApi({
                    dataVersion: this.month
                });
                this.editing = false;
            } finally {
                loading.close();
            }
            this.$message({
                type: "success",
                message: "发布成功!"
            });
            this.$router.go(-1)
        },
        async publish() {
            const res = await getReportPublishVersionApi();
            if (res.code == 200 && res.data.find(t => t.dataversion === this.month)) {
                this.$confirm("当前版本已存在发布数据，发布成功之后数据将被覆盖，请确认是否发布", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(async () => {
                    this.publishDone()
                }).catch(() => {
                    console.log("cancel confirm");
                });
            } else {
                this.publishDone()
            }
        },
        async reload() {
            this.$confirm("取消意味着放弃本次更改", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(async () => {
                this.getData3();
                this.editing = false;
                const ele = document.querySelector("#reportEditDetail");
                if (this.savedContent) {
                    ele.parentNode.replaceChild(this.savedContent, ele);
                }
                this.savedContent = ele.cloneNode(true);
            }).catch(() => {
                console.log("cancel confirm");
            });

        },
        async save() {
            const loading = this.$loading({
                lock: true,
                text: "保存中",
                background: "rgba(0, 0, 0, 0.7)"
            });
            try {
                await updateReportApi(this.data3Detail);
                this.editing = false;
                if (this.type === "new") {
                    this.$nextTick(() => {
                        this.$router.replace(`/report/edit?month=${this.month}`);
                    });
                }
            } finally {
                loading.close();
            }
        },
        async changeStatus(value, idx) {
            this.data3Detail[idx]["riskControllerStatus"] = value;
            this.data3[idx]["riskControllerStatus"] = value;
            // this.data3Detail[idx]['riskControllerStatus'] = 2
            // this.data3[idx]['riskControllerStatus'] = 2
            // console.log(this.data3Detail[idx]['riskControllerStatus'],value,'test')
            // TODO 修改状态之后和后端通信
            // const res = await xxxApi()
            // if (res.code === 200) {
            //     this.data3Detail[idx]["riskStatus"] = value;
            // }
        },
        deleteNode(e, riskIdx, title) {
            this.$confirm("确认要删除该区域吗", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(async () => {
                if(title == 'green'){
                    let target = e.target;
                    console.log(target)
                    while (target?.className?.indexOf("deleteGreenWrap") === -1) {
                        target = target.parentNode
                        console.log(target)
                    }
                    target.remove();

                    this.data3Detail[riskIdx]['deleteTitleList'] = this.data3Detail[riskIdx]['deleteTitleList'] || [];
                    this.data3Detail[riskIdx]['deleteTitleList'] = this.data3[riskIdx]['deleteTitleList'] 
                    this.data3Detail[riskIdx]['deleteTitleList'].push('allDelete')
                    this.$set(this.data3, riskIdx, this.data3Detail[riskIdx]);
                }else{
                    let target = e.target;
                    while (target?.className?.indexOf("section") === -1) {
                        target = target.parentNode
                    }
                    if (target) {
                        target.remove();
                        this.data3Detail[riskIdx]['deleteTitleList'] = this.data3Detail[riskIdx]['deleteTitleList'] || [];
                        this.data3Detail[riskIdx]['deleteTitleList'].push(title)
                        this.$set(this.data3, riskIdx, this.data3Detail[riskIdx]);
                    }
                }
                
            }).catch(() => {
                console.log("cancel confirm");
            });
        },
        handleInput(e) {
            if (e.target.contentEditable === "true" && e.target.dataset?.key) {
                const key = e.target.dataset.key;
                const innerText = e.target.innerText;
                const keys = key.split("_");
                this.setData(keys, innerText);
            }
        },
        setData(keys, data) {
            let current = this.data3Detail;
            while (keys.length > 1) {
                current = current[keys.shift()];
            }
            if (current) {
                current[keys.shift()] = data;
            }
        },
        viewImg(url) {
            const previewRef = this.$refs.img;
            if (!previewRef) return;
            this.previewList = [url];
            this.$nextTick(() => {
                previewRef.clickHandler();
            });
        },
        deleteImg(riskIdx, imgIdx) {
            this.$confirm("确认要删除该图片吗", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(async () => {
                const images = this.data3Detail[riskIdx]?.images || [];
                images.splice(imgIdx, 1);
                this.data3Detail[riskIdx] = {
                    ...this.data3Detail[riskIdx],
                    images
                };
                this.$set(this.data3, riskIdx, this.data3Detail[riskIdx]);
            }).catch(() => {
                console.log("cancel confirm");
            });
        },
        async exportReport2() {
            const loading = Loading.service({
                lock: true,
                text: "正在导出报告...",
                background: "rgba(0,0,0,0.5)",
                fullscreen: true
            });
            this.$nextTick(async () => {
                setTimeout(async () => {
                    try {
                        const list = [];
                        // list.push(...document.querySelectorAll(".pie"));
                        // list.push(...document.querySelectorAll(".table"));
                        list.push(...document.querySelectorAll(".detail > div"));
                        await pdf(list, {
                            exclude: "no-print",
                            paging: "page_split"
                        });
                    } finally {
                        loading.close();
                    }
                }, 200);
            });
        },
        async customUpload({ file }, riskIdx) {
            if (!file) return
            const images = this.data3Detail[riskIdx]?.images || [];
            const name = file.name.split(".")?.[0] || file.name;
            const res = await uploadReportImgApi(file, name);
            if (res.code === 200) {
                this.$nextTick(() => {
                    images.push(res.data);
                    this.data3Detail[riskIdx] = {
                        ...this.data3Detail[riskIdx],
                        images
                    };
                    this.$set(this.data3, riskIdx, JSON.parse(JSON.stringify(this.data3Detail[riskIdx])));
                })
            }
        },
        // async beforeUpload(file, riskIdx) {
        //     const imgs = this.data3Detail[riskIdx]?.imgs || [];
        //     // if (imgs.length >= 4) {
        //     //     this.$message.error("最多只能上传4张图片");
        //     //     return false;
        //     // }
        //     console.log(file);
        //     const res = await uploadReportImgApi(file, file.name);
        //     console.log(res);
        //     if (res.code === 200) {
        //         console.log(res.data)
        //     }
        //
        //     // imgs.push({
        //     //     url: URL.createObjectURL(file),
        //     //     name: "图片名称"
        //     // });
        //     // this.data3Detail[riskIdx] = {
        //     //     ...this.data3Detail[riskIdx],
        //     //     imgs
        //     // };
        //     return false;
        // },
        getUnit(companyName) {
            return ''
            switch (companyName) {
                case "香港万安公司":
                    return "万港币";
                case "意大利SALOV公司":
                    return "万欧元";
                case "光明食品亚太有限公司":
                    return "万元";
                case "光明国际":
                    return "万澳元";
                default:
                    return "";

            }
        },
        async getData() {
            await this.getData1();
            await this.getData2();
            this.getData3();
        },
        // 获取概览数据
        async getData1() {
            const data1 = await getReportOverviewApi({dataVersion: this.month});
            if (data1.code == 200) {
                this.data1 = {
                    ...(data1.data || {})
                };
            }
            return Promise.resolve()
        },
        //   获取饼状图数据
        async getData2() {
            const data2 = await getReportPieDataApi({dataVersion: this.month});
            if (data2.code == 200) {
                this.data2 = data2.data;
            }
            return Promise.resolve()
        },
        // 获取详情数据
        async getData3() {
            const loading = this.$loading({
                lock: true,
                text: "加载中",
                background: "rgba(0, 0, 0, 0.65)"
            });
            try {
                const requestMap = {
                    "new": buildReportApi,
                    "edit": getReportDetailByVeApi,
                    "origin": getOriginReportDetailApi
                }
                if (!requestMap[this.type]) return
                const data3 = await requestMap[this.type]({
                    dataVersion: this.month
                });
                if (data3.code == 200) {
                    const list = (data3.data || []).sort((a, b) => {
                        if (a.companyName === b.companyName) {
                            return sortedKeys.indexOf(a.riskCategory) - sortedKeys.indexOf(b.riskCategory);
                        }
                        return sortedCompanys.indexOf(a.companyName) - sortedCompanys.indexOf(b.companyName);
                    });
                    this.data3 = list.map(risk => {
                        return {
                            ...risk,
                            images: risk.images || [],
                            deleteTitleList: risk.deleteTitleJson || [],
                            riskControllerStatus: risk.riskControllerStatus === 9 ? 0 : risk.riskControllerStatus
                        }
                    });
                    this.data3Detail = JSON.parse(JSON.stringify(this.data3));
                }
            } finally {
                loading.close();
            }

        }

    },
    mounted() {
    },
    beforeDestroy() {
    }
};
</script>
<style lang="less" scoped>
@import "../assets/less/report.less";
.deleteiconwrap{
        .el-icon-delete{
            margin-left: 12px;
            cursor: pointer;
            display: none;
        }
        &:hover {
            .el-icon-delete {
                &:hover{
                    color: #409eff;
                }
                display:inline-block !important;
            }
        }
    }
.report-wrapper {
    width: 1180px;
    margin: 0 auto;
    padding-top: 60px;
}

.report-header {
    background-color: rgb(39, 49, 59);
    margin-bottom: 20px;
    text-align: center;
    color: #fff;
    font-size: 24px;
    line-height: 60px;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;

    .handle-btn {
        position: absolute;
        height: 100%;
        left: 20px;
        top: 0;
        z-index: 10;
    }

    .export-btn {
        position: absolute;
        height: 100%;
        right: 20px;
        top: 0;
        z-index: 10;
    }
}

.report {
    height: 100%;
    width: 100%;
    margin: 0 auto;
    background-color: #fff;
    overflow-y: auto;
    padding: 0;
    font-size: 14px;


    * {
        cursor: default;
    }

    p[contenteditable="true"] {
        cursor: text;
        border: 1px solid #b3b3b3;
        border-radius: 4px;
        padding: 2px;
        //&:hover {
        //    text-decoration: underline;
        //}

    }
    span {
        white-space: pre-wrap;
    }

    :focus-visible {
        outline: none;
    }


    .part2 {
        padding-bottom: 20px;
    }

    .detail {
        font-size: 18px;

        u {
            text-decoration: none;
        }

        .select-wrapper {
            ::v-deep {
                .el-input.is-disabled .el-input__inner {
                    cursor: default;
                }
            }
        }

        .img-wrapper {
            padding-bottom: 20px;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;

            .img-item {
                height: 325px;
                width: 49%;
                flex-grow: 0;
                flex-shrink: 0;
                display: flex;
                flex-direction: column;
                justify-content: space-between;

                .img-name {
                    font-size: 16px;
                    margin-bottom: 10px;
                    flex-shrink: 0;
                    flex-grow: 0;
                    p {
                        word-break: break-all;
                    }
                }

                .img-content {
                    flex-grow: 1;
                    border: 1px solid #eee;
                    background-repeat: no-repeat;
                    background-size: contain;
                    border-radius: 4px;
                    position: relative;

                    .img-handler {
                        display: none;
                        position: absolute;
                        top: 0;
                        left: 0;
                        bottom: 0;
                        right: 0;
                        background-color: rgba(0, 0, 0, 0.6);
                        align-items: center;
                        justify-content: center;
                        column-gap: 10px;

                        i {
                            font-size: 20px;
                            color: #aaa;
                            cursor: pointer;

                            &:hover {
                                color: #fff
                            }
                        }
                    }

                    &:hover {
                        .img-handler {
                            display: flex;
                        }
                    }
                }
            }
        }
    }

    ::v-deep {
        .el-input--mini {
            font-size: 14px;

            .el-input__inner {
                line-height: 1.5em;
                height: 1.5em;
                font-weight: bold;
                padding: 0;
                border: none;
            }

            .el-input__suffix {
                display: none;

                .el-input__icon {
                    line-height: 1.5em;
                }
            }

            &:hover {
                .el-input__suffix {
                    display: block;
                }
            }
        }
    }
   
    //处理dom删除icon的样式
    p {
        & > .el-icon-delete {
            margin-left: 12px;
            cursor: pointer;
            display: none;

            &:hover {
                color: #409eff;
            }
        }
        &:hover {
            & > .el-icon-delete {
                display: inline-block;
            }
        }
    }

}


</style>
